// Surname for the scoreboard line. A full Player exposes user.lastName; a
// summary-only player (e.g. one who has left the roster) only carries a
// precomputed full name, so take its last token.
const surname = (player) => {
    if ("user" in player) {
        return player.externalUser?.lastName ?? player.user?.lastName ?? undefined;
    }
    const parts = (player.name ?? "").trim().split(/\s+/);
    return parts.length ? parts[parts.length - 1] : undefined;
};
export const formatScorer = (player, stats) => {
    if (!player)
        return undefined;
    if (stats?.goalsScored) {
        const goalsScored = stats.goalsScored === 1 ? "" : ` (${stats.goalsScored})`;
        return `${surname(player)}${goalsScored}`;
    }
    return undefined;
};
/** Surname of a player who was sent off (a red recorded), else undefined. */
export const formatSentOff = (player, stats) => {
    if (!player)
        return undefined;
    if ((stats?.redCards ?? 0) > 0) {
        return surname(player);
    }
    return undefined;
};
